var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgentHoodFailedIconExclamation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FC9460"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7.62518C15.2016 7.62518 14.9155 7.74371 14.7045 7.95469C14.4935 8.16567 14.375 8.45181 14.375 8.75018V17.7502C14.375 18.0486 14.4935 18.3347 14.7045 18.5457C14.9155 18.7567 15.2016 18.8752 15.5 18.8752C15.7984 18.8752 16.0845 18.7567 16.2955 18.5457C16.5065 18.3347 16.625 18.0486 16.625 17.7502V8.75018C16.625 8.45181 16.5065 8.16567 16.2955 7.95469C16.0845 7.74371 15.7984 7.62518 15.5 7.62518Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 22.2502C16.625 21.6289 16.1213 21.1252 15.5 21.1252C14.8787 21.1252 14.375 21.6289 14.375 22.2502C14.375 22.8715 14.8787 23.3752 15.5 23.3752C16.1213 23.3752 16.625 22.8715 16.625 22.2502Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentHoodFailedIconExclamation);
export default __webpack_public_path__ + "static/media/AgentHoodFailedIconExclamation.bc9a56cb1f90e0332c2c0ea42e30e23f.svg";
export { ForwardRef as ReactComponent };